// assets/bg-dots.js
(function () {
  var MIN_WIDTH = 1024; // solo escritorio
  var canvas, ctx;
  var points = [];
  var mouse = {
    x: window.innerWidth / 2,
    y: window.innerHeight / 2,
    active: false
  };

  // Centro del campo que sigue al ratón con retraso
  var center = {
    x: window.innerWidth / 2,
    y: window.innerHeight / 2
  };

  var animationId;
  var width, height, dpr;

  // CONFIGURACIÓN PRINCIPAL
  var POINT_DENSITY = 0.0007;       // densidad de puntos en toda la pantalla
  var MAX_POINTS = 2600;            // límite de seguridad para rendimiento
  var BASE_RADIUS = 1.3;            // radio base de cada "punto"
  var MAX_ELONGATION = 2.4;         // cuánto se estiran (escala extra)
  var EFFECT_RADIUS = 380;          // radio alrededor del centro donde aparece el efecto
  var WAVE_SPACING = 55;            // distancia entre "anillos" de onda
  var WAVE_SPEED = 2.3;             // velocidad de la onda
  var FOLLOW_SPEED = 0.01;          // qué tan rápido el campo sigue al ratón (0.03 = muy lento, 0.2 = muy rápido)
  var TIME = 0;

  function init() {
    if (window.innerWidth < MIN_WIDTH) return;

    createCanvas();
    initPoints();

    window.addEventListener("resize", handleResize);
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseleave", handleMouseLeave);

    startAnimation();
  }

  function createCanvas() {
    canvas = document.createElement("canvas");
    canvas.id = "bg-dots-canvas";
    canvas.setAttribute("aria-hidden", "true");

    // Fondo absoluto detrás de todo
    canvas.style.position = "fixed";
    canvas.style.top = "0";
    canvas.style.left = "0";
    canvas.style.width = "100%";
    canvas.style.height = "100%";
    canvas.style.pointerEvents = "none";
    canvas.style.zIndex = "-1";

    document.body.appendChild(canvas);

    ctx = canvas.getContext("2d");
    resizeCanvas();
  }

  function resizeCanvas() {
    dpr = window.devicePixelRatio || 1;
    width = window.innerWidth;
    height = window.innerHeight;

    canvas.width = width * dpr;
    canvas.height = height * dpr;

    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function initPoints() {
    points = [];

    var area = width * height;
    var targetCount = Math.floor(area * POINT_DENSITY);
    var numPoints = Math.min(targetCount, MAX_POINTS);

    for (var i = 0; i < numPoints; i++) {
      points.push({
        x0: Math.random() * width,
        y0: Math.random() * height
      });
    }
  }

  function handleResize() {
    if (window.innerWidth < MIN_WIDTH) {
      destroy();
      return;
    }

    if (!canvas) {
      init();
      return;
    }

    resizeCanvas();
    initPoints();
  }

  function handleMouseMove(e) {
    mouse.x = e.clientX;
    mouse.y = e.clientY;
    mouse.active = true;
  }

  function handleMouseLeave() {
    mouse.active = false;
  }

  function startAnimation() {
    function frame() {
      animationId = window.requestAnimationFrame(frame);
      TIME += 0.016;
      draw();
    }
    frame();
  }

  function updateCenter() {
    // El centro del efecto persigue al ratón con un poquito de retraso
    if (mouse.active) {
      center.x += (mouse.x - center.x) * FOLLOW_SPEED;
      center.y += (mouse.y - center.y) * FOLLOW_SPEED;
    } else {
      // Si el ratón sale, el centro se queda donde estaba (campo "congelado")
      // Podrías hacer que vuelva al centro de la pantalla si quieres:
      // center.x += (width / 2 - center.x) * (FOLLOW_SPEED * 0.02);
      // center.y += (height / 2 - center.y) * (FOLLOW_SPEED * 0.02);
    }
  }

  function draw() {
    if (!ctx) return;

    updateCenter(); // <- aquí suavizamos el movimiento del campo

    ctx.clearRect(0, 0, width, height);

    // Color un poco oscuro pero sutil
    ctx.fillStyle = "rgba(40, 40, 40, 0.35)";

    var centerX = center.x;
    var centerY = center.y;

    for (var i = 0; i < points.length; i++) {
      var p = points[i];

      var dx = centerX - p.x0;
      var dy = centerY - p.y0;
      var dist = Math.sqrt(dx * dx + dy * dy) || 0.0001;

      // Solo mostramos puntos dentro de un radio alrededor del centro
      if (dist > EFFECT_RADIUS) continue;

      var t = dist / EFFECT_RADIUS; // 0 = centro, 1 = borde del radio

      // Cerca del centro casi desaparecen, hacia el borde se hacen visibles
      var visibility = Math.pow(t, 1.2);

      // Onda radial que se desplaza hacia fuera
      var wavePhase = dist / WAVE_SPACING - TIME * WAVE_SPEED;
      var wave = Math.cos(wavePhase);
      var waveFactor = (wave + 1) / 2; // 0 a 1

      var intensity = visibility * waveFactor;

      if (intensity < 0.08) continue;

      var r = BASE_RADIUS + 1.0 * intensity;
      var elongation = 1 + MAX_ELONGATION * intensity;

      var angle = Math.atan2(dy, dx);

      var offset = 10 * intensity * (wave - 0.5);
      var ox = p.x0 + (dx / dist) * offset;
      var oy = p.y0 + (dy / dist) * offset;

      ctx.save();
      ctx.translate(ox, oy);
      ctx.rotate(angle);
      ctx.scale(elongation, 1);

      ctx.beginPath();
      ctx.arc(0, 0, r, 0, Math.PI * 2);
      ctx.fill();

      ctx.restore();
    }
  }

  function destroy() {
    if (animationId) {
      window.cancelAnimationFrame(animationId);
      animationId = null;
    }

    if (canvas && canvas.parentNode) {
      canvas.parentNode.removeChild(canvas);
    }

    canvas = null;
    ctx = null;
    points = [];

    window.removeEventListener("resize", handleResize);
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseleave", handleMouseLeave);
  }

  document.addEventListener("DOMContentLoaded", init);
})();
